import styled from 'styled-components';

export const VideoPlayer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const Video = styled.video`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #dfdfdf;
  box-shadow: inset 1px 0px 13px 8px rgba(183, 183, 183, 0.19);
`;

export const ReplayIcon = styled.div`
  color: white;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 100%;
  padding: 16px;
`;

export const FullScreenIcon = styled.div`
  color: white;
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 16px;
`;
